export enum MerchantAccountTag {
  Membership = 'merchant_acct_membership',
  Permitting = 'merchant_acct_permitting',
  Storefront = 'merchant_acct_storefront',
}
